module.exports = __webpack_public_path__ + "media/images/illust/illust-lifeplanner-f1c28329f379314cf36ee9285c3f770d.svg";